import React from 'react'
import map from 'lodash/map'
import filter from 'lodash/filter'
import classnames from 'classnames'
import Checkmark from '@Images/exportation_popup_content_checkmark.svg'

import '@SiteComponents/SearchDropdown/SearchDropdown.scss'
import './ContentToExport.scss'

interface ContentToExportProps {
  readonly availableContent: string[]
  readonly contentToExport: string[]
  setContentToExport(newContentToExport: string[]): void
}

const ContentToExport: React.FC<ContentToExportProps> = props => {
  const {
    availableContent,
    contentToExport,
  } = props

  const contentToExportList = map(availableContent, (content, index) => {
    const isSelected = contentToExport.includes(content)

    const toggleContent = () => {
      if (isSelected) {
        props.setContentToExport(filter(contentToExport, ct => ct !== content))
      } else {
        props.setContentToExport(contentToExport.concat(content))
      }
    }

    return (
      <li
        key={index}
        className={classnames(
          'ContentToExport__item',
          { 'ContentToExport__item-selected': isSelected }
        )}
        onClick={toggleContent}
      >
        <Checkmark
          className={classnames(
            'ContentToExport__item-checkmark',
            { 'ContentToExport__item-checkmark-selected': isSelected }
          )}
        />
        {content}
      </li>
    )
  })

  const renderContentToExport = () => {
    return (
      <ul className="ContentToExport__items">
        {contentToExportList}
      </ul>
    )
  }

  return (
    <div className="ContentToExport">
      {renderContentToExport()}
    </div>
  )
}

export default ContentToExport
